export var breakpointSm = '480px';
export var breakpointMd = '768px';
export var breakpointLg = '1024px';
export var breakpointXl = '1280px';
